<template>
  <div>
    <payment-form
      payment-list="/api/payment/list/archive"
      @close="$router.push('/admin/payment/list')"
      @list="$router.push('/admin/payment/list/archive')"
      @view="id=> $router.push('/admin/payment/archive/view?id=' + id)"
    />
  </div>
</template>

<script>
export default {
  props: ['create', 'change', 'view'],
  data: () => ({

  }),
  computed: {

  },
  watch: {

  },
  methods: {

  },
}
</script>
